import { Component } from "../components/index"
import gsap from "gsap"
import { qsa, qs } from "../utils/index"

export default class HeroBlog extends Component {
  constructor(obj) {
    super(obj)

    gsap.set(this.el, { autoAlpha: 0 })

    this.animate()
  }

  animate() {
    const articles = qsa(".article-left, .article-center", this.el)

    gsap.from(articles, {
      y: 100,
      autoAlpha: 0,
      stagger: 0.2,
      duration: 1.2,
    })

    gsap.set(this.el, { autoAlpha: 1 })
  }
}
